export default __webpack_public_path__ + "static/media/news_arrow.6fe8c2cf.svg";